/**
 * MiBodega - Tipos compartidos
 * DTOs, enums y constantes usadas por backend y frontend
 */
export const CURRENCY_CODES = ['COP', 'USD', 'VES', 'EUR', 'USDT'];
export const ROLES_SISTEMA = ['ADMIN', 'VENDEDOR', 'CAJERO', 'BODEGUERO', 'CONTADOR'];
// ============================================
// Re-exports
// ============================================
export * from './money';
//# sourceMappingURL=index.js.map